export interface DurationData {
  duration_days?: number;
  duration_hours?: number;
  duration_minutes?: number;
}

export const formatDuration = (
  duration_days?: number,
  duration_hours?: number,
  duration_minutes?: number,
): string | undefined => {
  if (!duration_days && !duration_hours && !duration_minutes) {
    return undefined;
  }

  return `${duration_days ?? 0} ${(duration_hours ?? 0).toString().padStart(2, '0')}:${(
    duration_minutes ?? 0
  )
    .toString()
    .padStart(2, '0')}:00`;
};

export const parseDuration = (durationString?: string, field?: string[]): DurationData => {
  if (!durationString || durationString.includes('undefined')) {
    return {
      [field?.[0] as keyof DurationData]: 365,
      [field?.[1] as keyof DurationData]: 0,
      [field?.[2] as keyof DurationData]: 0,
    };
  }

  const parts = durationString?.split(' ');

  if (parts[0].includes(':')) {
    const timeParts = parts[0].split(':');
    const hours = parseInt(timeParts?.[0]) || 0;
    const minutes = parseInt(timeParts?.[1]) || 0;

    return {
      [field?.[0] as keyof DurationData]: 0,
      [field?.[1] as keyof DurationData]: hours,
      [field?.[2] as keyof DurationData]: minutes,
    };
  } else {
    const days = parseInt(parts[0]) || 0;
    const timeParts = parts[1]?.split(':') || ['0', '0', '0'];
    const hours = parseInt(timeParts[0]) || 0;
    const minutes = parseInt(timeParts[1]) || 0;

    return {
      [field?.[0] as keyof DurationData]: days,
      [field?.[1] as keyof DurationData]: hours,
      [field?.[2] as keyof DurationData]: minutes,
    };
  }
};
